import "babel-polyfill";
import "classlist-polyfill";
import Vue from "vue";
import axios from "./router/axios";
import VueAxios from "vue-axios";
import App from "./App";
import "./permission"; // 权限
import "./error"; // 日志
import "./cache"; //页面缓冲
import router from "./router/router";
import store from "./store";
import { loadStyle, downBlobFile, downBlobFilePost } from "./util";
import { validatenull } from "./util/validate";
import * as urls from "@/config/env";
import { iconfontUrl, iconfontVersion,iconfontVersionNewList,iconfontUrlNewList } from "@/config/env";
import * as filters from "./filters"; // 全局filter
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/common.scss";
import AvueFormDesign from "@sscfaith/avue-form-design";
import basicContainer from "./components/basic-container/main";
import commonList from "./components/common-list";
import echarts from 'echarts'
import qs from 'qs'
import VueClipboard from 'vue-clipboard2'

import vcrontab from "vcrontab";

import '@/util/directives';
const configAll = require('./util/configAll.cjs')
const UtilFn = require('./util/UtilFn.cjs')
import { XLSXFn } from './util/common/XLSXFn'
// 注册全局的自定义弹窗组件
import Dialog from '@/components/Dialog'
// 注册全局的自定义提示组件
import Tip from '@/components/Tip'
// 注册全局的DivWidth组件
import DivWidth from '@/components/DivWidth'
// 注册全局的Gap组件
import Gap from '@/components/Gap'
// 注册全局的自定义title组件
import ArticleTitle from '@/components/articleTitle'
// 注册全局的base-editor组件
import BaseEditor from '@/components/base-editor'
//解密
import VueCryptojs from 'vue-cryptojs'

// 运行时全局挂载appBuildInfo
import appBuildInfo from './appBuildInfo.json'
window.appBuildInfo = appBuildInfo


// 挂载常用全局方法，import 引入
Vue.prototype.validatenull = validatenull
Vue.prototype.downBlobFile = downBlobFile
Vue.prototype.downBlobFilePost = downBlobFilePost
Vue.prototype.Config = configAll.Config
Vue.prototype.$qs = qs
Vue.prototype.$elMsg = ElementUI.Message
// 自定义Loading对象的show和hide方法
const Loading = {
  show: function (options = { fullscreen: true }) {
    this.loadingInstance = ElementUI.Loading.service(options)
  },
  hide: function () {
    this.loadingInstance.close()
  }
}
Vue.prototype.Loading = Loading
Vue.prototype.UtilFn = UtilFn
Vue.prototype.XLSXFn = XLSXFn

// 插件 json 展示
Vue.use(router);
// 表单设计器
Vue.use(AvueFormDesign);

window.axios = axios;
Vue.use(VueAxios, axios);

Vue.use(ElementUI, {
  size: "small",
  menuType: "text",
});

Vue.use(AVUE, {
  size: "small",
  menuType: "text",
});

// 注册全局容器
Vue.component("basicContainer", basicContainer);
Vue.component("commonList", commonList);
Vue.component('chart', echarts)
Vue.component('Dialog', Dialog)
Vue.component('Tip', Tip)
Vue.component('DivWidth', DivWidth)
Vue.component('Gap', Gap)
Vue.component('ArticleTitle', ArticleTitle)
Vue.component('BaseEditor', BaseEditor)
Vue.use(VueCryptojs)
Vue.use( VueClipboard )
// code转换器
Vue.use( vcrontab );

// 加载相关url地址
Object.keys(urls).forEach((key) => {
  Vue.prototype[key] = urls[key];
});

// 加载过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// 动态加载阿里云字体库
iconfontVersion.forEach((ele) => {
  loadStyle(iconfontUrl.replace("$key", ele));
});

iconfontVersionNewList.forEach((ele) => {
  loadStyle(iconfontUrlNewList.replace("$key", ele));
});

Vue.config.productionTip = false;

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
